export default __webpack_public_path__ + "static/media/explosion.5db3e3f2.wav";